import "./log_monitor";
import "./log_timestamps"; // Importing this after log_monitor causes timestamps to be included in monitored logs.

import moment from 'moment';
import React from 'react';
import ReactDOM from 'react-dom';
import './style/style.scss';
import 'moment/locale/sv';
import { createAppMeta } from './app_meta';
import MainRouter from "./components/MainRouter";

createAppMeta();

moment.locale('sv');

ReactDOM.render(
  <React.StrictMode>
    <MainRouter />
  </React.StrictMode>,
  document.getElementById('root')
);
